module.exports = __webpack_public_path__ + "img/pic03.e8171fcb.png";